<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableF',title:'销售样表（外）'},{title:'销量样表（外）编辑页面'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true"
                              class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>销售样表信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Bianji">
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="f.prodcode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input v-model="f.prodseries" readonly></el-input>
                                            </el-form-item>


                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <el-input :v="f.userCode" placeholder="请输入工号" v-model="f.userCode" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                                            </el-form-item>
                                         <!--   <el-form-item label="状态" class="h-elformWrap-2">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"/>
                                            </el-form-item>-->
                                            <el-form-item label="型号属性" class="h-elformWrap-2">
                                                <!--<el-input v-model="f.protype" readonly></el-input>-->
                                                <el-select v-model="f.protype" placeholder="请选择">
                                                    <el-option value="自产">自产</el-option>
                                                    <el-option value="OEM">OEM</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <el-input placeholder="定价后自动带出" v-model="f.factory" disabled></el-input>
                                            </el-form-item>
											<el-form-item label="有效期" class="h-elformWrap-2">
											    <el-date-picker placeholder="请输入"
											                    v-model="f.validperiod"
											                    value-format="yyyy-MM-dd"
											                    :clearable="false"></el-date-picker>
											</el-form-item>
                                          <el-form-item label="是否增值服务" class="h-elformWrap-2" prop="isValueAddedService">
                                            <el-select v-model="f.isValueAddedService" :v="f.isValueAddedService" placeholder="请选择">
                                              <el-option v-for="(item) in fwList"
                                                         :key="item.code"
                                                         :label="item.name"
                                                         :value="item.code">
                                              </el-option>
                                            </el-select>
                                          </el-form-item>
                                            <el-form-item label="区域" class="h-elformWrap-1">
                                                <brselectlazy :multiple="true" category="neibu_haiwai_area" :v="f.areacode" v-model="f.areacode" style="width:100%"/>
                                            </el-form-item>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updatelist">确认修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
	import ss from '../../api/SystemService'
	export default {
		data() {
			return {
					//带线表单
				f: {
				},
				loading: false,
        fwList:[
          {code:1,name:"是"},
          {code:0,name:"否"}
        ],
			}
		},
		created() {
			this.query();
		},
		methods: {
			query() {
				this.f.id = this.$route.query.id;
				ss.salesListF.selectById(this.f.id).then(rd => {
					this.f = rd;
				})
			},
			backS() {
				this.$router.push({path: "/chanp/salesTableF"});
			},
			updatelist() {
				ss.salesListF.updateById(this.f).then(rd => {
					this.$msg.msgs("操作成功");
					this.$router.push({path: "/chanp/salesTableF"});
				})
			},

		}
	}
</script>

<style>
	.Bianji .h-elformWrap-2 .el-form-item__label {
		width: 26%;
		text-align: right;
	}
	.Bianji .h-elformWrap-2 .el-form-item__content {
		width: 74%;
	}
	.Bianji .h-elformWrap-1 .el-form-item__label {
		width: 8%;
		text-align: right;
	}
	.Bianji .h-elformWrap-1 .el-form-item__content {
		width: 92%;
	}
	.Bianji .h-elformWrap-2 {
		width: 33.333% !important;
		padding-right: 0.5rem
	}
	.Bianji .h-elformWrap-1 {
		width: 100%;
		padding-right: 0.5rem
	}
</style>
